import Vue from 'vue';

// --- Vuex Persist ---
import VuexPersistence from 'vuex-persist';

// --- LocalForage ---
import localforage from "localforage";

localforage.config({
    name: '3pos_pickupmonitor',
    version: 1.0,
    storeName: 'keyvaluepairs',
    description: 'Storage for pickupmonitor of 3POS'
});

const vuexLocal = new VuexPersistence({
    storage: window.localStorage, // window.localStorage
});

import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
    strict: false,
    plugins: [vuexLocal.plugin],
    state:{
        auth:{
            bsid: null,
            bs: null,
            socketServer: null,
        },
    },
    getters:{
        bsid:(state)=> state.auth.bsid,
        bs:(state)=> state.auth.bs,
        socketServer:(state)=> state.auth.socketServer,
        auth:(state)=> state.auth,
    },
    mutations:{
        setAuth(state,payload){
            state.auth.bs = payload.bs
            state.auth.bsid = payload.bsid
            state.auth.socketServer = payload.socketServer
        },
    },
    actions:{

    }
})